<template>
	<div class="app-container">
    <div>
      <el-button size="small" style="margin-bottom: 20px" type="primary" @click="goBack()">返回</el-button>
    </div>
		<el-table border v-loading="loading" :data="uploadTasks" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px">
			<el-table-column label="来源" prop="from" align="center"></el-table-column>
			<el-table-column label="文件" prop="orgName" align="center"></el-table-column>
			<el-table-column :key="processkey" label="进度" prop="process" align="center">
				<template #default='scope'>
					<el-progress :percentage="getPercentage(scope.row)" :format="format" :indeterminate="true">
					</el-progress>
				</template>
			</el-table-column>
			<el-table-column label="状态" prop="status" align="center">
				<template #default="scope">
					{{scope.row.status | uploadStatusTransform}}
				</template>
			</el-table-column>
			<el-table-column label="备注" prop="remarks" show-overflow-tooltip align="center"></el-table-column>
			<el-table-column :key="operatorkey" label="操作" align="center">
				<template #default='scope'>
					<el-button size="small" v-if="scope.row.status !== 3" @click="toggleUploadStates(scope.row)">
						{{scope.row.status === 1 ? "取消" :"重新上传"}}
					</el-button>
					<el-button size="small" @click="removeTask(scope.$index,scope.row)" type="danger">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>

</template>

<script>
	import Vue from 'vue'
	import {
		getUploadList,
		cancelUpload,
		resumeUpload,
		removeTask,
		setUploadCallback,
		removeUploadCallback
	} from "@/utils/uploadManager"
	import {
		printObj
	} from "@/utils/debug"
	import {
		randomRange
	} from "@/utils/keyutils"
	import {
		isVaild
	} from "@/utils/validate"
	export default {
		data() {
			return {
				loading: false,
				uploadTasks: [],
				processkey: 100, //不加key进度不刷新
				operatorkey: 100
			}
		},
		created() {
			console.log('on created')
			this.processkey = this.getRandomKey()
			this.operatorkey = this.getRandomKey()
			this.getAllUploadTask()
			this.setUploadCallback((p, cp, res) => {
				// console.log('----- upload listener ' + p + " " + cp + " " + res)
				//key改变，刷新界面
				this.processkey = this.getRandomKey()
				Vue.nextTick(() => {
					this.getAllUploadTask()

					// this.$forceUpdate()
				})
			})

		},
		destroyed() {
			this.removeUploadCallback()
		},
		methods: {
      goBack(){
        this.$router.go(-1)
      },
			getPercentage(entity) {
				return isVaild(entity.process) ? entity.process * 100 : 0
			},
			getRandomKey() {
				return randomRange(1, 10000);
			},
			format(percentage) {
				console.log("format " + percentage)
				if (isVaild(percentage)) {
					return `${percentage.toFixed(2)}%`
				} else {
					return "0%"
				}

			},
			getAllUploadTask() {
				this.uploadTasks = getUploadList()
			},
			setUploadCallback(callback) {
				setUploadCallback(callback)
			},
			removeUploadCallback() {
				removeUploadCallback()
			},
			pauseUpload(info) {
				pauseUpload(info)
			},
			resumeUpload(info) {
				resumeUpload(info)
			},
			toggleUploadStates(info) {
				if (info.status === 1) {
					cancelUpload(info)
				} else {
					resumeUpload(info)
				}
				this.operatorkey = this.getRandomKey()
			},
			removeTask(index, info) {
				removeTask(info)
			}
		},
	}
</script>

<style>
</style>
